import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './base.css';
import './styles.css';
// Hand-written styles for the surfaces the mock never had (sign-in, sharing,
// crew, admin). Loaded after styles.css so it can lean on the tokens declared
// there — and kept separate because styles.css is regenerated.
import './app.css';
// The class calculator's own page. Separate again because it is one public tool
// that shares no surface with the app, and can be read or removed on its own.
import './classcalc.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root — index.html did not load as expected');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
